import type { IncidentDetailResponse } from '@prerender/diagnostics-api';

import IncidentActionsView from './IncidentActionsView';
import { useRecordVerdictMutation } from './incidentsApi';

type IncidentActionsProps = {
  incident: IncidentDetailResponse;
};

function IncidentActions({ incident }: IncidentActionsProps): JSX.Element {
  const [recordVerdict, { isLoading, isSuccess, error }] = useRecordVerdictMutation();
  // An accepted verdict closes the incident, but the buttons would live on until the
  // refetch carrying that says so lands. A second click in the gap meets a refusal
  // about a verdict that in fact succeeded.
  const acted = isLoading || isSuccess;

  return (
    <IncidentActionsView
      closed={incident.status === 'closed'}
      acted={acted}
      refusal={error}
      onCloseIncident={() => {
        recordVerdict({ reference: incident.reference, verdict: 'close' });
      }}
    />
  );
}

export default IncidentActions;
